/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from "../core/index.js";
import { toJson } from "../core/json.js";

export class LangfuseAPIError extends Error {
  public readonly statusCode?: number;
  public readonly body?: unknown;
  public readonly rawResponse?: core.RawResponse;

  constructor({
    message,
    statusCode,
    body,
    rawResponse,
  }: {
    message?: string;
    statusCode?: number;
    body?: unknown;
    rawResponse?: core.RawResponse;
  }) {
    super(buildMessage({ message, statusCode, body }));
    Object.setPrototypeOf(this, LangfuseAPIError.prototype);
    this.statusCode = statusCode;
    this.body = body;
    this.rawResponse = rawResponse;
  }
}

function buildMessage({
  message,
  statusCode,
  body,
}: {
  message: string | undefined;
  statusCode: number | undefined;
  body: unknown | undefined;
}): string {
  let lines: string[] = [];
  if (message != null) {
    lines.push(message);
  }

  if (statusCode != null) {
    lines.push(`Status code: ${statusCode.toString()}`);
  }

  if (body != null) {
    lines.push(`Body: ${toJson(body, undefined, 2)}`);
  }

  return lines.join("\n");
}
